class TimeFormatter {
    toHoursAndMinutes(timeInMinutes: number): string {
      if (timeInMinutes === 0) {
        return "0h";
      }
      const hours = Math.floor(timeInMinutes);
      const minutes = Math.round((timeInMinutes - hours) * 60);
      return `${hours}h ${minutes}m`;
    }
  }
  
  export default TimeFormatter;